import { render, staticRenderFns } from "./CameraVue.vue?vue&type=template&id=0907a3b2&scoped=true"
import script from "./CameraVue.vue?vue&type=script&lang=js"
export * from "./CameraVue.vue?vue&type=script&lang=js"
import style0 from "./CameraVue.vue?vue&type=style&index=0&id=0907a3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0907a3b2",
  null
  
)

export default component.exports